import { useEffect, useState } from 'react';
import { useMasterData } from '../../context/MasterDataContext';

const useKarat = () => {
  const [karatOptionId, setKaratOptionId] = useState('');
  const [karatOption, setKaratOption] = useState([]);
  const { settings, isLoaded, karatList } = useMasterData();

  useEffect(() => {
    if (karatList && karatList.length > 0) {
      setKaratOption(karatList);
    } else if (isLoaded) {
      if (settings && settings.karat_options) {
        const arr = String(settings.karat_options).split(',').map((item) => item.trim()).filter(Boolean);
        const parsedArr = arr.map(Number).filter((n) => !isNaN(n));
        setKaratOption(parsedArr.length > 0 ? parsedArr : [16, 17, 18, 19, 20, 21, 22, 23, 24]);
      } else {
        setKaratOption([16, 17, 18, 19, 20, 21, 22, 23, 24]);
      }
    } else {
      setKaratOption([16, 17, 18, 19, 20, 21, 22, 23, 24]);
    }
  }, [settings, isLoaded, karatList]);

  return {
    karatOption,
    setKaratOptionId,
    karatOptionId,
  };
};

export default useKarat;
